import { GetCompaniesForUserQuery } from '@neo.tax/shared/graphql';

import { SortValueMapper } from '../sort-popover';
import { sortableColumns } from './company-list.columns';

type CompanySortableColumn = (typeof sortableColumns)[number]['name'];

export const mapSortValues: SortValueMapper<
  NonNullable<GetCompaniesForUserQuery['getCompaniesForUser']>[number],
  CompanySortableColumn
> = (column, item) => {
  switch (column) {
    case 'companyName':
      return item.shortName || item.legalName || null;
    case 'lastChange':
      return item.fiscalYears[0]?.rdTaxCredit?.lastUpdatedAt ?? null;
  }
  return null;
};
